import { render } from "./EditableColumn.vue?vue&type=template&id=50463a68&scoped=true"
import script from "./EditableColumn.vue?vue&type=script&lang=js"
export * from "./EditableColumn.vue?vue&type=script&lang=js"

import "./EditableColumn.vue?vue&type=style&index=0&id=50463a68&scoped=true&lang=less"

import exportComponent from "/Users/islibaodong/IdeaProjects/2024/Titan-Frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-50463a68"]])

export default __exports__